import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  Row,
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import ProposalClientSearch from "./proposal-client-search";
import TooltipButton from "../../../ui/tooltip-button";
import RadioButton from "../../../ui/custom-radio";
import Origins from "./origins";
import { fireEvent } from "../../../../utils/google-analytics-handler";
import "../css/proposals.scss";

const Proposals = ({ proposals, selected, select, customSelect }) => {
  const { selectedClient } = useSelector(state => state.clients);
  const reducedProposal = proposals.slice(0, 3);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const selectedOrigins = reducedProposal && proposals[selected] ? proposals[selected].origins : [];
  const selectedRules = (reducedProposal && proposals[selected] && proposals[selected].rules
    ? proposals[selected].rules
    : []
  ).map(x => {
    return {
      name: x.name,
      value: x.description
    };
  });
  return (
    <Card className="h-100 origins-menu">
      <CardHeader className="d-flex align-items-center justify-content-between">
        <h3>Propuestas de conciliación</h3>
        <Dropdown direction="left" isOpen={menuOpen} toggle={() => setMenuOpen(!menuOpen)}>
          <DropdownToggle tag="div" className="btn-group">
            <TooltipButton
              tag="a"
              buttonClassName="navbar-more"
              iconClassName="icono-more"
              tooltipText="Ver algoritmo"
              onClick={() => setMenuOpen(!menuOpen)}
            />
          </DropdownToggle>
          <DropdownMenu className="menu-more dropdown-menu-right">
            <DropdownItem onClick={() => setIsPopupVisible(true)}>
              <div>Información del algoritmo</div>
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
        {isPopupVisible && (
          <Origins
            isVisible={isPopupVisible}
            toggle={() => setIsPopupVisible(false)}
            origins={selectedOrigins}
            rules={selectedRules}
          />
        )}
      </CardHeader>
      <CardBody>
        <ListGroup
          className={`proposals-levels ${
            reducedProposal.length > 1 ? "justify-content-around" : ""
          }`}
        >
          {reducedProposal.map(({ tercero, name }, i) =>
            reducedProposal.length !== i + 1 ? (
              <ListGroupItem key={`proposals_${tercero}`} active={selected === i}>
                <Row className="d-flex align-items-center">
                  <div className="col-1">
                    <span className={`level-circle ${selected === i ? "selected" : ""}`}>
                      <span>{i + 1}</span>
                    </span>
                  </div>
                  <div className="col-9 level-literal">
                    {`${tercero}${name ? ` - ${name}` : ""}`}
                  </div>
                  <div className="col-1">
                    <RadioButton
                      selectColor="#22959e"
                      isSelected={selected === i}
                      tooltipPosition="left"
                      tooltipText={
                        selected === i
                          ? "Propuesta seleccionada para conciliar"
                          : "Ver esta propuesta"
                      }
                      onChange={() => {
                        select(i);
                        fireEvent("ConciliationProposal", "Select", null, i);
                      }}
                    />
                  </div>
                </Row>
              </ListGroupItem>
            ) : (
              <ProposalClientSearch
                selectedClient={selectedClient || null}
                select={sapCode => {
                  customSelect(sapCode, i);
                  fireEvent("ConciliationProposal", "Select", null, i);
                }}
                isSelected={selected === i}
                moreThanOneProposal={reducedProposal.length > 1}
                index={i}
              />
            )
          )}
        </ListGroup>
      </CardBody>
    </Card>
  );
};

Proposals.propTypes = {
  proposals: PropTypes.arrayOf(
    PropTypes.shape({
      origins: PropTypes.arrayOf(PropTypes.shape({})),
      rules: PropTypes.arrayOf(PropTypes.shape({})),
      tercero: PropTypes.string
    })
  ),
  selected: PropTypes.number,
  select: PropTypes.func,
  customSelect: PropTypes.func
};

Proposals.defaultProps = {
  proposals: [],
  selected: 0,
  select: () => {},
  customSelect: () => {}
};

export default Proposals;
